import { configureStore } from '@reduxjs/toolkit';
import { combineReducers } from 'redux';
import createSagaMiddleware from 'redux-saga';
import { all } from 'redux-saga/effects';
import logger from 'redux-logger';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import cacheReducer from '@store/slice/cache-slice';
import authReducer from '@store/slice/auth-slice';
import userReducer from '@store/slice/user-slice';
import newsletterReducer from '@store/slice/newsletter-slice';
import navigationReducer from '@store/slice/navigation-slice';
import modalReducer from '@store/slice/modal-slice';
import gridgioModalReducer from '@store/slice/gridgio/modal-slice';
import testReducer from '@store/slice/test-slice';
import errorReducer from '@store/slice/error-slice';
import hubReducer from '@store/slice/hub-slice';
import studentReducer from '@store/slice/student-slice';
import workbookReducer from '@store/slice/workbook-slice';
import applicationReducer from '@store/slice/application-slice';
import classroomReducer from '@store/slice/classroom-slice';
import adminReducer from '@store/slice/admin-slice';
import vocabularyBookReducer from '@store/slice/vocabulary-book-slice';
import speakingReducer from '@store/slice/speaking-slice';

export function* rootSaga() {
  yield all([]);
}

const sagaMiddleware = createSagaMiddleware();
const middleware: any = [sagaMiddleware];

if (process.env.NODE_ENV === 'development') {
  middleware.push(logger);
}

// combine으로 합치지 않아도 됩니다. (코드정리를 위해 rootReducer로 묶었습니다.)
const rootReducer = combineReducers({
  cacheReducer,
  authReducer,
  userReducer,
  newsletterReducer,
  navigationReducer,
  modalReducer,
  gridgioModalReducer,
  testReducer,
  errorReducer,
  hubReducer,
  studentReducer,
  workbookReducer,
  applicationReducer,
  classroomReducer,
  adminReducer,
  vocabularyBookReducer,
  speakingReducer,
});

// redux persist 설정
const persistConfig = {
  key: 'root',
  version: 1,
  storage,
  blacklist: ['authReducer', 'cacheReducer'],
};
const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = configureStore({
  reducer: { rootReducer: persistedReducer },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [
          'persist/PERSIST',
          'persist/REHYDRATE',
          'persist/PAUSE',
          'persist/FLUSH',
          'persist/PURGE',
          'persist/REGISTER',
        ],
      },
    }).concat(middleware),
});

sagaMiddleware.run(rootSaga);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export default store;

// TODO: 배포되면 Persistance Store를 비워야할듯 (이상하게 설정됨)
